import { useCallback, useEffect, useState } from 'react'
import Fuse from 'fuse.js'

import { RequestUserConfig } from '../../common/types'
import { eventClient } from '../../clients'
import { useRequestUserConfigContext } from '../../hooks/request'
import { useAsyncCallback } from '../../hooks/async'
import RegionsGeolocationTransport from '../../transports/event/regions-geolocation-transport'
import EventRegionsAutocompleteSuggestionTransport from '../../transports/event/event-regions-autocomplete-suggestion-transport'

const _getEventRegionsGeolocation = async (user: RequestUserConfig) => {
    const response = await eventClient.getRegionsGeolocation({ user })

    return response.data
}

export const useEventsRegionsGeolocation = () => {
    const user = useRequestUserConfigContext()

    const {
        data: regionsGeolocation,
        isLoading,
        error,
        saveAsync,
        callback,
    } = useAsyncCallback<RegionsGeolocationTransport>(_getEventRegionsGeolocation)

    const getEventsRegionsGeolocation = useCallback(() => callback(user), [callback, user])

    return {
        regionsGeolocation: regionsGeolocation as RegionsGeolocationTransport,
        isLoading,
        error,
        getEventsRegionsGeolocation,
        setEventsRegionsGeolocation: saveAsync,
    }
}

export const useEventRegionsGeolocationLocationPicker = () => {
    const [data, setData] = useState<EventRegionsAutocompleteSuggestionTransport[]>([])

    const { regionsGeolocation, getEventsRegionsGeolocation } = useEventsRegionsGeolocation()

    useEffect(() => {
        getEventsRegionsGeolocation().then()
    }, [getEventsRegionsGeolocation])

    const getRegionsGeolocationFuseSearchResult = useCallback(
        (regionName: string) => {
            if (!regionsGeolocation || !regionsGeolocation.cities) {
                return data
            }
            const regionsGeolocationArray = Object.values(regionsGeolocation.cities)
            const options = {
                includeScore: true,
                includeMatches: true,
                keys: ['name'],
            }

            const fuse = new Fuse(regionsGeolocationArray, options)
            const result = fuse.search(regionName).slice(0, 5)
            const regionSuggestions: EventRegionsAutocompleteSuggestionTransport[] = result.map(region => {
                return region.item.name
            })

            setData(regionSuggestions)

            return regionSuggestions
        },
        [regionsGeolocation, data],
    )

    return {
        regionsSuggestions: data,
        getRegionSuggestions: getRegionsGeolocationFuseSearchResult,
        setRegionSuggestions: setData,
    }
}
